// removed by extract-text-webpack-plugin
module.exports = {"alertPopup":"styles__alertPopup__3by8w","List":"styles__List__3gHSg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Forms/DraftForms/styles.css
// module id = 159
// module chunks = 0